import { makeImageUrls, ImageProps } from "@ezbuy/smartimagesrc";

import { bannerPlaceholder456 } from "utils/playground/banner";

const defaultImage = bannerPlaceholder456;

export function* imageSourceGenerator(
	originSrc: string,
	params: ImageProps,
	fallbackSrc: string | false = defaultImage,
) {
	const urls = makeImageUrls(originSrc, params);

	if (fallbackSrc) {
		urls.push(fallbackSrc);
	}
	for (let i = 0, l = urls.length; i < l; i++) {
		yield urls[i];
	}
	return originSrc;
}

export function transformImageTights(src: string) {
	let transformSrc = src;
	if (src.match(/tights\.rightinthebox\.com\/tights/)) {
		transformSrc = src.replace(/tights\.rightinthebox/, "t.rightinthebox");
	}
	return transformSrc;
}